var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('datatable',{attrs:{"title":"Vetting Recipes","response":_vm.data,"fields":_vm.fields},on:{"delete":_vm.deleteRecipe,"create":_vm.createNewRecipe,"edit_click":_vm.editRecipe}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }